import { IKogModalProps } from '@/main/@types/interfaceIcons';
import KogModalSideComponent from '@/main/components/modal/ModalSide';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import HubContainer from '@/main/components/shared/hub/HubContainer';
import { KOGAreaButtonsModal } from '@/main/components/shared/styles';
import { SendUpdatesSignalRTypeEnum } from '@/main/services/enum/SendUpdatesSignalRTypeEnum';
import { getTranslateByKey } from '@/main/services/utils';
import React from 'react'

interface IModalPrequoteSignalRProps extends IKogModalProps { }
function ModalPrequoteSignalR({
  closeModal
}: IModalPrequoteSignalRProps) {
  return (
    <div>
      <HubContainer
        type={SendUpdatesSignalRTypeEnum.PreQuote}
        customProps={{}}
      />
      <KOGAreaButtonsModal>
        <SecondaryButton
          onClick={() => { closeModal() }}
        >
          {getTranslateByKey('information.close')}
        </SecondaryButton>
      </KOGAreaButtonsModal>
    </div>
  )
}

function WrapperModalPrequoteSignalR(props: IModalPrequoteSignalRProps) {
  return (
    <KogModalSideComponent
      shouldRenderOpen
      open={props.isOpenModal}
      closeModal={() => props.setIsOpenModal(false)}>
      <ModalPrequoteSignalR {...props} />
    </KogModalSideComponent>
  );
}

export default WrapperModalPrequoteSignalR